import * as React from "react";
import { forwardRef } from "react";
const SvgIcoArrowUp = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M4.53637 15.6953L11.5579 8.67382C11.7533 8.47838 12.0702 8.47859 12.2654 8.67428L19.2683 15.6953", stroke: "currentColor", strokeWidth: 1.8, strokeLinecap: "round" }));
const ForwardRef = forwardRef(SvgIcoArrowUp);
export default ForwardRef;
